@import '../../vars.css';

.size-500,
.size-600,
.size-800,
.size-1140,
.fullscreen {
    padding: var(--modal-s-content-paddings);

    &:last-child {
        padding-bottom: var(--modal-s-content-only-bottom-padding);
    }
}
